import { render, staticRenderFns } from "./TabNavigation.vue?vue&type=template&id=5376ae99&scoped=true"
import script from "./TabNavigation.vue?vue&type=script&lang=js"
export * from "./TabNavigation.vue?vue&type=script&lang=js"
import style0 from "./TabNavigation.vue?vue&type=style&index=0&id=5376ae99&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5376ae99",
  null
  
)

export default component.exports